import { createContext } from 'react';

const NursingContext = createContext();

export default NursingContext;
